import { render, staticRenderFns } from "./SettingsInstances.vue?vue&type=template&id=0f251795&scoped=true"
import script from "./SettingsInstances.vue?vue&type=script&lang=js"
export * from "./SettingsInstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f251795",
  null
  
)

export default component.exports